import 'what-input'

console.log('v-0.0.27')

$(() => {
  const syosContainer = document.querySelector('.tn-syos')

  if (syosContainer) {
    $('body').addClass('tn-syos-active')
  }

  // Open Menu
  //
  let scrollPosition = $(window).scrollTop()
  const toggleMobileMenu = function () {
    if (!$('body').hasClass('nav-open')) {
      scrollPosition = $(window).scrollTop()
    }

    $('body').toggleClass('nav-open nav-closed')
    $('html').toggleClass('nav-open')

    $('html, body').scrollTop(scrollPosition)
  }
  $('.c-navigation-trigger').on('click', toggleMobileMenu)

  /**
 * Make Marketing Preferences Mandatory - Updated V16
 */
  const requiredLabel = '<small aria-hidden="true" class="tn-required-field pull-right">Required</small>'
  const requiredErrorMessage = '<div class="help-block">This field is required.</div>'

  // Function to make marketing preferences mandatory
  const mandatoryMarketingPref = () => {
    // Wait until DOM has loaded required help blocks
    if (!$('#tn-cust-category-help-block-1-4').length) {
      setTimeout(mandatoryMarketingPref, 500)
      return
    }

    // Add "Required" label to fields
    $('#contactPermissionsApp fieldset').prepend(requiredLabel)

    // Disable submit button initially
    $('#tn-account-register-button-register').prop('disabled', true)

    // Event handler for changes to any radio input
    $('input[name="tn-cust-field-contact_perm_kvp_1-1"], input[name="tn-cust-field-contact_perm_kvp_4-1"]').on('change', function () {
      const emailSelected = $('input[name="tn-cust-field-contact_perm_kvp_1-1"]:checked').length > 0
      const postSelected = $('input[name="tn-cust-field-contact_perm_kvp_4-1"]:checked').length > 0

      if (emailSelected) removeErrorMessage('tn-cust-field-contact_perm_kvp_1-1')
      if (postSelected) removeErrorMessage('tn-cust-field-contact_perm_kvp_4-1')

      if (emailSelected && postSelected) {
        $('#tn-account-register-button-register').prop('disabled', false)
      }
    })

    // Validate when trying to submit
    $('#tn-account-register-button-register').parent().on('click', function () {
      const emailSelected = $('input[name="tn-cust-field-contact_perm_kvp_1-1"]:checked').length > 0
      const postSelected = $('input[name="tn-cust-field-contact_perm_kvp_4-1"]:checked').length > 0

      if (!emailSelected) addErrorMessage('tn-cust-field-contact_perm_kvp_1-1')
      if (!postSelected) addErrorMessage('tn-cust-field-contact_perm_kvp_4-1')
    })
  }

  // Function to remove error messaging/styling
  const removeErrorMessage = (fieldName) => {
    const fieldset = $(`input[name="${fieldName}"]`).closest('fieldset')
    fieldset.removeClass('has-feedback has-error')
    fieldset.find('.help-block').last().next('.help-block').remove()
  }

  // Function to add error messaging/styling
  const addErrorMessage = (fieldName) => {
    const fieldset = $(`input[name="${fieldName}"]`).closest('fieldset')
    if (!fieldset.hasClass('has-error')) {
      fieldset.addClass('has-feedback has-error')
      fieldset.append(requiredErrorMessage)
    }
  }

  // Init
  mandatoryMarketingPref()

  // A price type placeholder box with white space characters
  // Hide it when there's no actual text inside
  const emptyElements = document.querySelectorAll('.tn-empty-cart-message, #instructions-choose-zone')
  if (emptyElements && emptyElements.length) {
    emptyElements.forEach(element => {
      if (!element.innerText.length) {
        element.style.display = 'none'
      }
    })
  }
})

// Append venue to body class
//
if ($(".tn-event-detail__location:contains('Guildhall')").length > 0) {
  $('body').addClass('state--venue-guildhall')
}

/*
 * Add body class to determine seatmap background
 */

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true }

// Callback function to execute when mutations are observed
const callback = function (mutationsList, observer) {
  // Use traditional 'for loops' for IE 11
  const $body = $('body')

  for (const mutation of mutationsList) {
    // Check for seat ID within each seatmap layout
    if (document.querySelector('.tn-syos-seat-map__seat[data-tn-seat-id="519740"]') && mutation.type === 'childList') {
      // If so then add body class, and remove other body classes if required
      $body.addClass('seatmap--587')
    }
    // Upper Circle
    if (document.querySelector('.tn-syos-seat-map__seat[data-tn-seat-id="233806"]') && mutation.type === 'childList') {
      $body.addClass('seatmap--upper-circle')
      $body.removeClass('seatmap--circle')
      $body.removeClass('seatmap--stalls')
    }
    // Circle
    if (document.querySelector('.tn-syos-seat-map__seat[data-tn-seat-id="231805"]') && mutation.type === 'childList') {
      $body.addClass('seatmap--circle')
      $body.removeClass('seatmap--stalls')
      $body.removeClass('seatmap--upper-circle')
    }
    // Stalls
    if (document.querySelector('.tn-syos-seat-map__seat[data-tn-seat-id="230516"]') && mutation.type === 'childList') {
      $body.addClass('seatmap--stalls')
      $body.removeClass('seatmap--circle')
      $body.removeClass('seatmap--upper-circle')
    }
  }
}

function addObserverIfDesiredNodeAvailable () {
  const targetNode = document.querySelector('.tn-syos')
  if (!targetNode) {
    // The node we need does not exist yet.
    // Wait 500ms and try again
    window.setTimeout(addObserverIfDesiredNodeAvailable, 500)
    return
  }
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback)

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config)
}
addObserverIfDesiredNodeAvailable()
